/*
 * Parlay lens TOGGLE controller (collection pages)
 * ------------------------------------------------------------------
 * Sibling to parlay-lens-swap.js (which drives the PDP off the selected
 * Lens variant). On the collection page there is no variant — the frosted
 * Day/Dusk tabs in the hero drive the swap directly. Clicking a tab flips
 *     <html data-active-lens="day|dusk">
 * instead of navigating, so the whole page (hero copy/photo, product grids,
 * mechanism clips) swaps with NO reload. Visibility itself is handled by
 * parlay-lens-swap.css off that single root attribute.
 *
 * The initial lens is stamped server-side (from the collection handle) in
 * the hero section, so the correct set paints first. The tab's href is kept
 * as a no-JavaScript fallback (it still points at the real collection).
 */
(function () {
  'use strict';

  var ROOT = document.documentElement;

  // Map any label / url / path to 'day' | 'dusk' | null (dusk keywords win).
  function lensKind(str) {
    if (!str) return null;
    var v = String(str).toLowerCase();
    if (v.indexOf('dusk') > -1 || v.indexOf('night') > -1 || v.indexOf('evening') > -1 || v.indexOf('sleep') > -1) return 'dusk';
    if (v.indexOf('everyday') > -1 || v.indexOf('day') > -1) return 'day';
    return null;
  }

  function allTabs() {
    return document.querySelectorAll('[data-lens-toggle] [data-lens-target]');
  }

  function syncTabs(kind) {
    allTabs().forEach(function (tab) {
      var active = tab.getAttribute('data-lens-target') === kind;
      tab.classList.toggle('active', active);
      if (active) {
        tab.setAttribute('aria-current', 'page');
      } else {
        tab.removeAttribute('aria-current');
      }
    });
  }

  function setLens(kind) {
    if (kind !== 'day' && kind !== 'dusk') return;
    if (ROOT.getAttribute('data-active-lens') !== kind) {
      ROOT.setAttribute('data-active-lens', kind);
      // let other scripts react (analytics, sticky bars, etc.)
      document.dispatchEvent(new CustomEvent('parlay:lens', { detail: { lens: kind } }));
    }
    syncTabs(kind);
  }

  function onTabClick(e) {
    var tab = e.currentTarget;
    var kind = tab.getAttribute('data-lens-target');
    if (kind !== 'day' && kind !== 'dusk') return; // unknown → let the link navigate
    e.preventDefault();
    setLens(kind);
    // Reflect the lens in the address bar (shareable, refresh-safe) without a reload.
    var href = tab.getAttribute('href');
    if (href && href.charAt(0) !== '#' && window.history && history.replaceState) {
      try { history.replaceState(null, '', href); } catch (err) {}
    }
  }

  function boot() {
    var tabs = allTabs();
    if (!tabs.length) return;
    tabs.forEach(function (tab) { tab.addEventListener('click', onTabClick); });

    // Initial sync: honor the server-stamped lens; else infer from the URL, else Day.
    var current = ROOT.getAttribute('data-active-lens');
    if (current !== 'day' && current !== 'dusk') {
      current = lensKind(window.location.pathname) || 'day';
      ROOT.setAttribute('data-active-lens', current);
    }
    syncTabs(current);

    // Back/forward across the two collection URLs → re-sync the lens.
    window.addEventListener('popstate', function () {
      var kind = lensKind(window.location.pathname);
      if (kind) setLens(kind);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
